export const sortOrderOptions = [
    { value: 'ASC', label: 'Datum oplopend' },
    { value: 'DESC', label: 'Datum aflopend' },
];

export const specialFilterOptions = [
    { value: 'pastDueFilter', label: 'Enkel toekomstige ritten' },
    { value: 'toInvoice', label: 'Te factureren ritten' },
    { value: 'noFilter', label: 'Alle' },
];

export const deliverdateToBePlannedOptions = [
    { value: -1, label: 'Filter' },
    { value: 0, label: 'Gepland' },
    { value: 1, label: 'Niet gepland' },
];

export const deliverdateRecurringOptions = [
    { value: '-1', label: 'Filter' },
    { value: '1', label: 'Terugkerend' },
    { value: '0', label: 'Niet terugkerend' },
];

export const clearedFilters = {
    deliverdatesortOrder: sortOrderOptions[0].value,
    deliverdatespecialFilter: specialFilterOptions[0].value,
    deliverdatesortField: '', //No longer in use, but added for completeness
    deliverdatefull: '',
    deliverdatenr: '',
    deliverdateToBePlanned: deliverdateToBePlannedOptions[0].value,
    deliverdatedate: '',
    deliverdateregion: '',
    deliverdatetype: '',
    deliverdatetruck: '-1',
    deliverdatedeliverymethod: '-1',
    deliverdaterecurring: '-1',
};

export function jaNeeToBool(full) {
    switch (full.toUpperCase()) {
        case 'JA':
            return '1';
        case 'NEE':
            return '0';
        default:
            return '';
    }
}

export function exportDeliveryDate(dateId, deliveryLists) {
    deliveryLists = deliveryLists || false;

    let url =
        Config.url +
        '/export/exportDeliveryDateDetails/?deliveryDateId=' +
        dateId;

    if (deliveryLists) {
        url += '&deliveryLists=true';
    }

    window.open(url);
}
